<template>
  <v-container fluid>
    <v-row>
      <v-col class="col-12 pt-0 pb-2">
        <h1>All Personnel</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-12 pt-0 pb-0">
        <router-link to="/admin/personnel-add">
          <v-btn x-small>
            Add new person
          </v-btn>
        </router-link>
        &nbsp;
        <router-link to="/admin/personnel-archive-index">
          <v-btn x-small>
            View archived
          </v-btn>
        </router-link>
        &nbsp;
        <router-link to="/admin/personnel-search">
          <v-btn x-small>
            Search
          </v-btn>
        </router-link>
        &nbsp;
        <router-link to="/admin/personnel-planning">
          <v-btn x-small>
            Attendance Planning
          </v-btn>
        </router-link>
        &nbsp;
        <router-link to="/admin/leave-requests">
          <v-btn x-small>
            Leave Requests
          </v-btn>
        </router-link>
        &nbsp;
        <router-link to="/admin/time-sheets">
          <v-btn x-small>
            Timesheets
          </v-btn>
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-simple-table
          fixed-header
          height="450px"
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Name</th>
                <th class="text-left">Is crew member?</th>
                <th class="text-left">Is team leader?</th>
                <th class="text-left">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(person, index) in personnel"
                :key="index"
              >
                <td>{{ person.name }}</td>
                <td>
                  <span v-if="person.isCrewMember">Yes</span>
                  <span v-else>No</span>
                </td>
                <td>
                  <span v-if="person.isTeamLeader">Yes</span>
                  <span v-else>No</span>
                </td>
                <td>
                  <router-link custom v-slot="{ navigate }" :to="`/admin/personnel-view/${person.id}`">
                    <v-btn
                      x-small
                      @click="navigate"
                      @keypress.enter="navigate"
                      role="link">
                      View
                    </v-btn>
                  </router-link>
                  &nbsp;
                  <router-link custom v-slot="{ navigate }" :to="`/admin/personnel-edit/${person.id}`">
                    <v-btn
                      x-small
                      @click="navigate"
                      @keypress.enter="navigate"
                      role="link">
                      Edit
                    </v-btn>
                  </router-link>
                  &nbsp;
                  <v-btn
                    x-small
                    @click="archivePerson(index)">
                    Archive
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-pagination
          class="pt-4"
          v-model="page"
          :length="length"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          :total-visible="totalVisible"
        ></v-pagination>
      </v-col>
    </v-row>
    <v-dialog
      v-model="warnArchive"
      max-width="290"
    >
      <v-card>
        <v-card-text class="pt-4">
          Are you sure you want to archive this person?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="confirmArchive"
          >
            Confirm
          </v-btn>
          <v-btn
            text
            @click="warnArchive = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from '../../../axios';

export default {
  name: 'AdminPersonnelIndex',
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  data() {
    return {
      personnel: [],
      page: 1,
      length: 0,
      totalVisible: 9,
      warnArchive: false,
      toArchive: -1,
    };
  },
  watch: {
    page() {
      this.getPersonnel();
    },
  },
  methods: {
    archivePerson(index) {
      this.toArchive = index;
      this.warnArchive = true;
    },
    confirmArchive() {
      const personId = this.personnel[this.toArchive].id;
      axios.get(`/personnel/archive/${personId}.json?token=${this.token}`)
        .then(() => {
          this.personnel.splice(this.toArchive, 1);
          this.warnArchive = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getPersonnel() {
      axios.get(`/personnel/getAll/${this.page}.json?token=${this.token}&archived=0`)
        .then((response) => {
          this.personnel = response.data.personnel;
          this.length = response.data.length;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.getPersonnel();
  },
};
</script>
